import { MarketingSEO } from '@/components/seo/MarketingSEO'
import { SEO_ROUTES } from '@/seo/seo-routes'
import IphoneMonitoringTopicTemplate from '@/components/IphoneMonitoringTopicTemplate'
import { iphoneMonitoringTopics } from '@/data/iphoneMonitoringTopics'

const topic = iphoneMonitoringTopics.find((t) => t.slug === 'joey-desktop')!
const related = iphoneMonitoringTopics.filter((t) => t.slug !== 'joey-desktop')

export default function IPhoneMonitoringJoeyDesktop() {
  return (
    <>
      <MarketingSEO
        title={topic.title}
        description={topic.seoDescription}
        url={SEO_ROUTES.iphoneMonitoringJoeyDesktop}
        image="/img/og/open_graph.png"
      />
      <IphoneMonitoringTopicTemplate topic={topic} relatedTopics={related} />
    </>
  )
}

